module.exports = __webpack_public_path__ + "img/ring-my-stylist-salespage-logo.3ff0a09c.png";